import {
  TextInput,
  createStyles,
  Text,
  Group,
  MantineTheme,
} from "@mantine/core";
import { CSS } from "@mantine/styles/lib/tss/types";
import { ChangeEvent, FC } from "react";

type Props = {
  labelText: string;
  id?: string;
  placeHolder?: string;
  onChange?: CallableFunction;
  style?: CSS;
  isErrored?: string;
  errorMessage?: boolean;
  value: string;
  type?: string;
  readOnly?: boolean;
  disabled?: boolean;
  shorterLength?: boolean;
};

const InputGroup: FC<Props> = ({
  id,
  labelText,
  placeHolder,
  type = "text",
  value,
  isErrored,
  errorMessage,
  onChange,
  readOnly,
  disabled,
  shorterLength,
}) => {
  const useStyles = createStyles((theme: MantineTheme) => ({
    mainContainer: {},
    text: {
      paddingBottom: "0px",
      paddingLeft: "0px",
      color: "inherit",
      textAlign: "left",
      overflow: "visible",
    },
    text1: {
      paddingBottom: "0px",
      paddingLeft: "0px",
      color: "inherit",
      textAlign: "left",
      overflow: "visible",
      marginBottom: "22px",
    },
    inputField: {
      paddingTop: "2px",
      height: "45px",
      width: "100%",
      marginBottom: "10px",
      border: isErrored ? `1px solid ${theme.colors.red[6]}` : undefined, // Apply error styling
      '& input[type="date"]:not(:focus):invalid::-webkit-datetime-edit': {
        color: "transparent",
      },
      '& input[type="date"]:not(:focus):invalid::before': {
        content: '"dd/mm/yyyy"',
        color: theme.colors.gray[5],
        position: "absolute",
      },
    },
    errorMessage: {
      color: theme.colors.red[6],
      position: "relative",
      bottom: "10px",
      fontSize: "14px",
    },
  }));
  const { classes } = useStyles();

  const OnChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e.target.value);
  };

  return (
    <div className={classes.mainContainer}>
      <Group position="left" mb={5}>
        {!shorterLength && (
          <Text
            className={classes.text}
            component="label"
            htmlFor={id}
            size="sm"
          >
            {labelText}
          </Text>
        )}
        {shorterLength && (
          <Text
            className={classes.text1}
            component="label"
            htmlFor={id}
            size="sm"
          >
            {labelText}
          </Text>
        )}
      </Group>
      <TextInput
        id={id}
        type={type}
        placeholder={placeHolder}
        className={classes.inputField}
        value={value}
        size="md"
        onChange={OnChangeInput}
        readOnly={readOnly}
        disabled={disabled}
      />
      {isErrored && errorMessage && (
        <div className={classes.errorMessage}>{isErrored}</div>
      )}
    </div>
  );
};

export default InputGroup;
